import React, { useEffect } from "react";
import ReactSwitch from "react-switch";
import useBindToContext from "hooks/useBindToContext";
import classNames from "lib/classNames";

const Switch = ({
	value,
	disabled = false,
	className = "",
	onChange,
	BindToContext = null,
	handleDiameter,
	width,
	height,
	onColor,
	offColor,
	onHandleColor,
	offHandleColor,
	onFocus,
	onBlur,
	noText = false
}) => {
	const [BindedValue, BindedOnChange, _, onRender] = useBindToContext(
		BindToContext,
		value,
		onChange
	);

	//useEffect(() => {
	//if (onRender?.length) onRender.forEach(fn => fn());
	//}, [onRender]);

	return (
		<ReactSwitch
			checked={BindedValue || false}
			onColor={onColor || "#68d391"}
			offColor={offColor || "#f6ad55"}
			disabled={disabled}
			onHandleColor={onHandleColor || "#FFFFFF"}
			offHandleColor={offHandleColor || "#FFFFFF"}
			handleDiameter={handleDiameter || 22}
			boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
			uncheckedIcon={false}
			height={height || 20}
			width={width || 47}
			onChange={BindedOnChange}
			className={`switch ${className}`}
			onFocus={(e) => {
				if (onFocus) onFocus(e);
			}}
			onBlur={(e) => {
				if (onBlur) onBlur(e);
			}}
			checkedIcon={
				noText ? false : (
					<div
						className={classNames(
							"flex-center h-full font-bold text-white pl-1"
						)}
						style={{ fontSize: "0.6em" }}
					>
						ON
					</div>
				)
			}
			uncheckedIcon={
				noText ? false : (
					<div
						className={classNames(
							"flex-center h-full font-bold text-white pr-1"
						)}
						style={{ fontSize: "0.6em" }}
					>
						OFF
					</div>
				)
			}
		/>
	);
};

export default Switch;
